export default "/images/fad7f136c97f909aed3e46f6e8f9d041.avif";